<mat-card class="portal-page-heading mb-4">
  <mat-card-content>
    <div class="flex flex-row flex-wrap justify-start items-center gap-4">
      <mat-icon class="portal-heading-icon" fontIcon="home_health"></mat-icon>
      <h1 class="portal-page-title">In Home Care</h1>
      <button *ngIf="license.id > 0" class="ml-auto" type="button" mat-raised-button color="accent"
        (click)="closeLicense()">Close</button>
    </div>
  </mat-card-content>
</mat-card>

<div class="flex flex-col pb-4 gap-4" *ngIf="licenseRequests.length > 0 && license.id === 0">
  <div *ngFor="let request of licenseRequests">
    <div class="flex flex-col md:flex-row gap-4">
      <div class="ihc-license-card-container">
        <mat-card>
          <mat-card-content>
            <div class="flex flex-col md:flex-row">
              <span class="text-xl font-bold">License Claim Request</span>
              <button class="ml-auto" type="button" mat-button color="warn" (click)="cancelLicenseRequest(request)">Cancel Request</button>
            </div>
            <div class="flex flex-col">
              <div class="flex flex-row items-center gap-4">
                <span class="text-lg font-semibold md:w-1/3">Owner Name</span>
                <span>{{request.owner}}</span>
              </div>
              <div class="flex flex-row items-center gap-4">
                <span class="text-lg font-semibold md:w-1/3">License Number</span>
                <span>{{request.licenseNumber}}</span>
              </div>
              <div *ngIf="!request.denied" class="flex flex-row items-center gap-4">
                <span class="text-lg font-semibold md:w-1/3">Request</span>
                <span class="portal-warning">Pending</span>
              </div>
              <div *ngIf="request.denied" class="flex flex-col">
                <span class="text-lg font-semibold portal-error">Claim Request Denied</span>
                <div class="flex flex-row gap-4 items-center">
                  <span class="text-lg font-semibold">Reason</span>
                  <span>{{request.deniedReason}}</span>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</div>

<div class="ihc-claim-card-container flex flex-col pb-4 gap-2">
  <!--
    Claim An Existing License
  -->
  <mat-card *ngIf="showClaimLicense && license.id === 0">
    <mat-card-content>
      <div class="flex flex-col">

        <div class="flex flex-col md:flex-row">
          <span class="text-xl font-bold">Claim an Existing License</span>
        </div>

        <form [formGroup]="requestForm">
          <div class="flex flex-col pt-4 gap-2">

            <div class="flex flex-col md:flex-row md:max-2xl:flex-wrap md:gap-4">
              <mat-form-field>
                <mat-label>Owner Name</mat-label>
                <input matInput formControlName="owner">
                <mat-error *ngIf="requestForm.get('owner')?.invalid">
                  Owner Required
                </mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>License Number</mat-label>
                <input matInput formControlName="licenseNumber">
                <mat-error *ngIf="requestForm.get('licenseNumber')?.hasError('invalidLicense')">
                  Cannot find license
                </mat-error>
              </mat-form-field>

              <mat-checkbox formControlName="ownerChange" labelPosition="before">
               <span class="text-lg">Claiming License as New Owner</span>
              </mat-checkbox>
            </div>

            <div class="flex flex-col md:flex-row md:max-2xl:flex-wrap md:gap-4">
              <mat-form-field>
                <mat-label>Street</mat-label>
                <input matInput formControlName="street">
                <mat-error *ngIf="requestForm.get('street')?.invalid">
                  You must provide a street address
                </mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>City</mat-label>
                <input matInput formControlName="city">
                <mat-error *ngIf="requestForm.get('city')?.invalid">
                  You must provide a city
                </mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>State</mat-label>
                <mat-select formControlName="state">
                  <mat-option *ngFor="let state of sharedService.states" value={{state}}>{{state}}</mat-option>
                </mat-select>
                <mat-error *ngIf="requestForm.get('state')?.invalid">
                  Please select a state
                </mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>Zip</mat-label>
                <input matInput formControlName="zip">
                <mat-error *ngIf="requestForm.get('zip')?.hasError('required')">
                  Zip is required
                </mat-error>
                <mat-error *ngIf="requestForm.get('zip')?.hasError('pattern')">
                  Zipcode should match this format: 99999 or 99999-1234
                </mat-error>
              </mat-form-field>
            </div>

            <div class="flex flex-col gap-2" *ngIf="requestForm.get('ownerChange')?.value">

              <span>If the IHC you are claiming will be a subunit of another agency provide the parent license number.</span>
              <div>
                <mat-form-field>
                  <mat-label>Parent License Number</mat-label>
                  <input matInput formControlName="parentId">
                  <mat-error *ngIf="requestForm.get('parentId')?.hasError('parentNotFound')">
                    Cannot find agency
                  </mat-error>
                </mat-form-field>
              </div>

              <span class="font-semibold">An In-Home Care agency is defined in Oregon Revised Statute (ORS) 443.315 as:
              an agency primarily engaged in providing in-home care services for compensation to an
              individual in that individual's place of residence.” Inhome care agency”
              does not include a home health agency or portion of an agency providing home health services as defined in ORS 443.005.</span>
              <span>1. I have read and I understand the In-Home Care licensure requirements
                set forth in ORS 443.305 to 443.350 and OARs Chapter 333, Division 536.</span>
              <span>2. Written policies and procedures, including applicable forms and curriculums,
                have been developed to direct all administrative, personnel, and client care operations of the agency.
                The policies and procedures are complete, clear, and ensure compliance with the in-home care agency OARs.</span>
              <span>3. Client care and documentation systems have been developed and implemented to ensure compliance with the In-Home Care licensure OARs.</span>
              <span>4. Personnel management and documentation systems have been developed and implemented to
                ensure employees meet all screening, qualification, orientation, and training requirements consistent with the in-home care agency OARs.</span>
              <span>5. Branch offices operated by the IHC are managed as required by the In-Home Care OARs.
                Systems to ensure that the parent IHC maintains control and oversight of the branch office(s) have been developed and implemented.</span>
              <span class="font-semibold">I attest, under penalties of perjury, that I have answered all the above questions to the best of my knowledge and belief;
                and that this information is true, correct and complete. I assume full responsibility for the ongoing operations of the IHC,
                including all branch offices, and its compliance with the applicable OARs.</span>
              <div class="flex flex-col md:flex-row gap-4 items-center">
                <mat-form-field class="md:w-1/3 h-20">
                  <mat-label>Signature</mat-label>
                  <input matInput formControlName="signature" (blur)="validateLicenseRequestSignature()">
                  <mat-error *ngIf="requestForm.get('signature')?.invalid">
                    Signature Required
                  </mat-error>
                </mat-form-field>

                <div class="flex flex-col gap-2 md:w-1/3">
                  <!-- <span class="font-semibold">Date Signed</span> -->
                  <mat-form-field>
                    <input placeholder="Date Signed" formControlName="dateSigned" matInput [matDatepicker]="dateSigned"
                           [max]="sharedService.today" (blur)="validateLicenseRequestDate()" />
                    <mat-datepicker-toggle matSuffix [for]="dateSigned"></mat-datepicker-toggle>
                    <mat-datepicker #dateSigned>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                    <mat-error *ngIf="requestForm.get('dateSigned')?.invalid">
                      Invalid Date
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>

          </div>
        </form>
        <div class="flex flex-col md:flex-row">
          <button class="ml-auto" *ngIf="requestForm.valid" type="button" mat-button color="primary" (click)="createLicenseRequest()">Claim</button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <!--
    Apply for a New License
  -->
  <mat-card class="ihc-apply-card" *ngIf="showClaimLicense && licenses.length === 0">
    <mat-card-header>
      <mat-card-title>
        <span class="text-xl font-bold">Apply For A New License</span>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="flex flex-row gap-8 justify-start items-center">
        <span class="text-lg">Start your application here.</span>
        <button class="ml-auto" mat-button color="primary" type="button" (click)="createLicense()">
          <span class="text-lg">Apply</span>
        </button>
      </div>
    </mat-card-content>
  </mat-card>

</div>

<div class="flex flex-col gap-4" *ngIf="licenses.length > 0 && license.id === 0">
  <div *ngFor="let license of licenses">
    <div class="flex flex-col md:flex-row gap-4">
      <div class="ihc-license-card-container">
        <mat-card class="w-full">
          <mat-card-header>
            <mat-card-title>
              <span class="text-xl font-bold">In Home Care License</span>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="flex flex-row">
              <div class="flex flex-col w-3/4">
                <div class="flex flex-row justify-start items-center gap-4">
                  <span class="text-base font-semibold w-2/3 md:w-1/3">{{licenseIsApproved(license.statuses)? 'License Number' : 'Pending License' }}</span>
                  <span class="text-base" id="licenseId">{{license.licenseId}}</span>
                  <button mat-icon-button (click)="sharedService.copyToClipboard(license.licenseId ?? '')" color="primary"
                    matTooltip="Copy to Clipboard" matTooltipShowDelay=800 aria-label="Copy to Clipboard">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </div>
                <div class="flex flex-row justify-start items-center gap-4">
                  <span class="text-base font-semibold w-2/3 md:w-1/3">Agency Name</span>
                  <span>{{ license.entityName }}</span>
                </div>
                <div class="flex flex-row justify-start items-center gap-4">
                  <span class="text-base font-semibold w-2/3 md:w-1/3">Classification</span>
                  <span>{{ license.classificationLevel }}</span>
                </div>
                <div class="flex flex-row justify-start items-center gap-4">
                  <span class="text-base font-semibold w-2/3 md:w-1/3">Status</span>
                  <div class="flex flex-col">
                    <div *ngFor="let status of license.statuses">
                      <span class="text-lg"
                            [ngClass]="status.label === sharedService.approved? 'portal-success' :
                                      status.label === sharedService.renewal? 'portal-warning' : ''">{{status.label}}</span>
                    </div>
                  </div>
                </div>
                <div class="flex flex-row gap-4">
                  <span class="text-base font-semibold w-2/3 md:w-1/3">Issued Date</span>
                  <span class="text-base">{{license.approvedDate | date}}</span>
                </div>
                <div class="flex flex-row gap-4">
                  <span class="text-base font-semibold w-2/3 md:w-1/3">Expiration Date</span>
                  <span class="text-base">{{license.expirationDate | date}}</span>
                </div>
              </div>

              <div class="flex flex-col items-end w-1/4">
                <button *ngIf="canRenew(license)" type="button" mat-button color="accent"
                  (click)="renewLicense(license.licenseId ?? '')">Begin Renewal</button>

                <button *ngIf="canSelect(license)" type="button" mat-button color="primary"
                  (click)="selectLicense(license)">{{ getSelectButtonLabel(license) }}</button>

                <button *ngIf="canViewSubunits(license)" type="button" mat-button color="primary"
                  (click)="viewSubunits(license)">View Subunits</button>

                <button *ngIf="licenseIsApproved(license.statuses)" type="button" mat-button color="primary"
                  (click)="openPDFDialog(license)">Print</button>

                <button *ngIf="canCancel(license)" type="button" mat-button color="warn"
                  (click)="cancelLicense(license)">Cancel</button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</div>

<div *ngIf="license.id > 0">
  <mat-stepper [orientation]="sharedService.isMobile? 'vertical' : 'horizontal'" #IHCLStepper linear (selectionChange)="changeStep($event)">
    <!--
      Begin Application
    -->
    <mat-step>
      <ng-template matStepLabel>
        <span matTooltip="Begin Application" matTooltipPosition="below" [matTooltipShowDelay]="500">Begin Application</span>
      </ng-template>

      <div class="flex flex-col md:flex-row gap-4">
        <div class="flex flex-col gap-4 md:w-1/2">
          <span class="text-lg pl-6">
            Complete the Owner/Administrator Background Check Request form(s) and include a resume.
            Please ensure that your administrator application and resume meets the following requirements:
          </span>
          <span class="text-lg pl-6">
            Must show evidence of at least two years of professional or management experience in a health related
            field or program
            (Please include the employer's name and location, the dates of employment
            including month and year, the title of the position held, and the duties performed).
          </span>
          <span class="text-lg pl-6">
            You must provide evidence of high school diploma or equivalent
          </span>
        </div>

        <div class="flex flex-col gap-4 md:w-1/2">
          <div class="flex flex-col md:flex-row gap-4 items-center">
            <span class="text-lg font-semibold">Select the classification level you are applying for</span>
            <button class="ml-auto" type="button" *ngIf="approved" mat-button color="primary"
            (click)="requestChange(0, sharedService.classification, sharedService.change)">
              Change Classification</button>
          </div>

          <form [formGroup]="licenseForm">
            <div class="flex flex-col">
              <mat-form-field appearance="fill" class="flex-col gap-2">
                <input matInput formControlName="classificationLevel" style="display: none;">
                <mat-radio-group aria-labelledby="classification level" formControlName="classificationLevel">
                  <mat-radio-button value="Limited">
                    <span class="font-semibold text-lg underline pr-4">Limited</span>
                    <span>An agency that provides personal care services that may include
                      medication reminding but does not provide medication assistance, medication administration, or nursing
                      services.</span>
                  </mat-radio-button>
                  <mat-radio-button value="Basic">
                    <span class="font-semibold text-lg underline pr-4">Basic</span>
                    An agency that provides personal care services that may include
                    medication reminding and medication assistance but does not provide medication administration or nursing
                    services.
                  </mat-radio-button>
                  <mat-radio-button value="Intermediate">
                    <span class="font-semibold text-lg underline pr-4">Intermediate</span>
                    An agency that provides personal care services that may include
                    medication reminding, medication assistance and medication administration but does not provide nursing
                    services.
                  </mat-radio-button>
                  <mat-radio-button value="Comprehensive">
                    <span class="font-semibold text-lg underline pr-4">Comprehensive</span>
                    An agency that provides personal care services that may include
                    medication reminding, medication assistance, medication administration, and nursing services.
                  </mat-radio-button>
                </mat-radio-group>
                <mat-error *ngIf="licenseForm.get('classificationLevel')?.invalid">
                  You must select a classification level
                </mat-error>
              </mat-form-field>

              <mat-checkbox formControlName="isSubunit" labelPosition="before">
               <span class="text-lg">This application is for a subunit</span>
              </mat-checkbox>

            </div>
          </form>
          <span *ngIf="licenseForm.get('isSubunit')?.value">
            The subunit must be at least 60 miles from the parent agency.
          </span>
        </div>
      </div>

      <button class="text-xl" mat-raised-button matStepperNext type="button">Next</button>
    </mat-step>

    <!--
      Agency Demographics
    -->
    <mat-step>
      <ng-template matStepLabel>
        <span matTooltip="Agency Information" matTooltipPosition="below" [matTooltipShowDelay]="500">Agency Demographics</span>
      </ng-template>
      <div class="pb-2">
        <span class="font-semibold text-xl">Agency Demographics</span>
      </div>

      <div class="flex flex-col md:flex-row gap-4">
        <div class="flex flex-col md:w-1/2">
          <form [formGroup]="licenseForm">
            <mat-card>
              <mat-card-content>
                <div class="flex flex-col gap-2">
                  <div class="flex flex-col" *ngIf="licenseForm.get('isSubunit')?.value">
                    <div class="flex flex-col md:flex-row gap-2">
                      <div class="flex flex-col gap-2 md:w-1/2">
                        <span class="font-semibold">Parent Agency</span>
                        <mat-form-field>
                          <mat-label>Parent</mat-label>
                          <input matInput formControlName="parentAgency" (blur)="getValidatedParentInfo()">
                          <mat-error *ngIf="licenseForm.get('parentAgency')?.hasError('parentNotFound')">
                            Cannot find parent agency
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="flex flex-col md:w-1/2">
                        <span class="font-semibold pb-2">Parent Info</span>

                        <div class="flex flex-row gap-4 items-center">
                          <span class="font-semibold md:w-1/4">License:</span>
                          <span>{{license.parentGuid}}</span>
                        </div>

                        <div class="flex flex-row gap-4 items-center">
                          <span class="font-semibold md:w-1/4">City:</span>
                          <span>{{license.parentCity}}</span>
                        </div>

                        <div class="flex flex-row gap-4 items-center" *ngIf="addressesLoaded">
                          <span class="font-semibold md:w-1/4">Distance:</span>
                          <span *ngIf="license.calculatedDistance > 0"
                            [ngClass]="license.calculatedDistance >= 60 || approved? 'portal-success' : 'portal-error'">
                            {{ license.calculatedDistance }} Miles</span>
                          <span *ngIf="license.calculatedDistance === 0 && !hasPhysicalAddress()" class="text-amber-600">Add Physical Address to Verify</span>
                          <span *ngIf="license.calculatedDistance === 0 && hasPhysicalAddress()" class="text-amber-600">Unable to Verify Distance</span>
                        </div>
                      </div>
                    </div>

                    <div class="flex flex-col">
                      <div *ngIf="license.calculatedDistance < 60 && license.calculatedDistance > 0 && !approved">
                        <span *ngIf="license.calculatedDistance > 59" class="text-amber-600">
                          The distance between the parent agency and this subunit appears to be fewer than 60 miles,
                          but is within a margin of error.
                          If you believe the subunit is 60 miles or greater from the parent agency you may submit your application.
                          A staff member will verify the distance and contact you if there are any issues.
                        </span>
                        <span *ngIf="license.calculatedDistance < 59" class="portal-error">
                          The distance between the parent agency and the subunit appears to be fewer than 60 miles. You
                          may not submit your application. Please contact the Health Care Regulation and Quality Improvement Section
                          for further assistance.
                        </span>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="approved">
                    <button class="-mb-4 -ml-2" type="button" *ngIf="license.isSubunit" mat-button color="primary"
                      (click)="requestChange(0, sharedService.parent, sharedService.change)">
                      Set as Parent Agency
                    </button>
                  </div>

                  <div class="flex flex-col md:flex-row gap-2 pb-8">
                    <div class="flex flex-col gap-2 md:w-1/2">
                      <div class="flex flex-row gap-4 items-center">
                        <span class="font-semibold">Agency Legal Name</span>

                        <button *ngIf="approved || license.isRenewal" class="ml-auto" type="button" mat-button [color]="licenseForm.get('entityName')?.disabled? 'primary' : 'warn'"
                          (click)="toggleEntityNameLock()">
                          {{licenseForm.get('entityName')?.disabled? 'Edit Legal Name' : 'Done'}}
                        </button>
                      </div>

                      <mat-form-field>
                        <mat-label>Legal Name</mat-label>
                        <input matInput formControlName="entityName" (blur)="validateAgencyName()">
                        <mat-error *ngIf="licenseForm.get('entityName')?.hasError('agencyNameRequired')">
                          You must include a name, and the name cannot contain 'Home Health'.
                        </mat-error>
                        <mat-error *ngIf="licenseForm.get('entityName')?.hasError('invalidName')">
                          This name is already used by another approved license.
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/2">
                      <span class="font-semibold" [ngClass]="approved || license.isRenewal? 'pt-4': ''">Agency DBA (Doing Business As) Name</span>
                      <mat-form-field>
                        <mat-label>DBA (Doing Business As) Name</mat-label>
                        <input matInput formControlName="agencyDBAName">
                        <mat-error *ngIf="licenseForm.get('agencyDBAName')?.hasError('required')">
                          DBA (Doing Business As) Name is required
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex flex-col md:flex-row gap-2">
                    <div class="flex flex-col gap-2 md:w-1/3">
                      <span class="font-semibold">Agency Phone</span>
                      <mat-form-field>
                        <mat-label>Phone</mat-label>
                        <input matInput formControlName="agencyPhone" mask="000-000-0000">
                        <mat-error *ngIf="licenseForm.get('agencyPhone')?.hasError('required')">
                          Phone number required
                        </mat-error>
                        <mat-error *ngIf="licenseForm.get('agencyPhone')?.hasError('pattern')">
                          Format number as 000-000-0000
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/3">
                      <span class="font-semibold">Agency Email</span>
                      <mat-form-field>
                        <mat-label>Email</mat-label>
                        <input matInput formControlName="agencyEmail">
                        <mat-error *ngIf="licenseForm.get('agencyEmail')?.hasError('required')">
                          Email is required
                        </mat-error>
                        <mat-error *ngIf="licenseForm.get('agencyEmail')?.hasError('email')">
                          Not a valid email
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/3">
                      <span class="font-semibold">Agency Fax</span>
                      <mat-form-field>
                        <mat-label>Phone</mat-label>
                        <input matInput formControlName="agencyFax" mask="000-000-0000">
                        <mat-error *ngIf="licenseForm.get('agencyFax')?.invalid">
                          Format number as 000-000-0000
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex flex-col md:flex-row gap-2">
                    <div class="flex flex-col gap-2 md:w-1/3">
                      <span class="font-semibold">Emergency Contact Name</span>
                      <mat-form-field>
                        <mat-label>Emergency Name</mat-label>
                        <input matInput formControlName="emergencyContactName">
                        <mat-error *ngIf="licenseForm.get('emergencyContactName')?.invalid">
                          Emergency contact required
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/3">
                      <span class="font-semibold">Emergency Contact Phone</span>
                      <mat-form-field>
                        <mat-label>Emergency Phone</mat-label>
                        <input matInput formControlName="emergencyContactPhone" mask="000-000-0000">
                        <mat-error *ngIf="licenseForm.get('emergencyContactPhone')?.hasError('required')">
                          Emergency number required
                        </mat-error>
                        <mat-error *ngIf="licenseForm.get('emergencyContactPhone')?.hasError('pattern')">
                          Format number as 000-000-0000
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/3">
                      <span class="font-semibold">Emergency Contact Email</span>
                      <mat-form-field>
                        <mat-label>Emergency Email</mat-label>
                        <input matInput formControlName="emergencyContactEmail">
                        <mat-error *ngIf="licenseForm.get('emergencyContactEmail')?.hasError('required')">
                          Emergency email required
                        </mat-error>
                        <mat-error *ngIf="licenseForm.get('emergencyContactEmail')?.hasError('pattern')">
                          Not a valid email
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>

            <mat-card>
              <mat-card-content>
                <div class="flex flex-col gap-2 pt-2">
                  <div class="flex flex-col md:flex-row gap-2">
                    <div class="flex flex-col gap-2 md:w-1/2">
                      <span class="font-semibold">Administrator Designee Name</span>
                      <mat-form-field>
                        <mat-label>Designee Name</mat-label>
                        <input matInput formControlName="adminDesigneeName">
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/2">
                      <span class="font-semibold">Admin Designee Title</span>
                      <mat-form-field>
                        <mat-label>Desginee Title</mat-label>
                        <input matInput formControlName="adminDesigneeTitle">
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex flex-col md:flex-row gap-2">
                    <div class="flex flex-col gap-2 md:w-1/2">
                      <span class="font-semibold">Qualified Individual/Entity Name</span>
                      <mat-form-field>
                        <mat-label>Entity Name</mat-label>
                        <input matInput formControlName="qualifiedEntityName">
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-2 md:w-1/2">
                      <span class="font-semibold">Qualified Individual/Entity Title</span>
                      <mat-form-field>
                        <mat-label>Entity Title</mat-label>
                        <input matInput formControlName="qualifiedEntityTitle">
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex flex-col gap-2 md:w-1/2"
                       *ngIf="licenseForm.get('classificationLevel')?.value === 'Intermediate' ||
                              licenseForm.get('classificationLevel')?.value  === 'Comprehensive'">

                    <div class="flex flex-col md:flex-row md:gap-2 items-center">
                      <span class="font-semibold"><strong>Registered Nurse Name</strong></span>
                      <button class="ml-auto" type="button" *ngIf="approved || license.isRenewal" mat-button color="primary"
                              (click)="requestChange(0, sharedService.nurse, sharedService.change)">
                        Request Change</button>
                    </div>

                    <mat-form-field>
                      <mat-label>Nurse Name</mat-label>
                      <input matInput formControlName="registeredNurseName" (blur)="validateRegisteredNurse()">
                      <mat-error *ngIf="licenseForm.get('registeredNurseName')?.invalid">
                        Registered nurse name required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </form>

          <app-office-hours [entityId]="license.id"
                            [entityType]="sharedService.inHomeCareLicense">
          </app-office-hours>
        </div>

        <div class="flex flex-col md:w-1/2 gap-4">
          <mat-card>
            <mat-card-content>
              <div class="flex flex-col gap-4">
                <div class="flex flex-row">
                  <button *ngIf="approved || license.isRenewal" type="button" mat-button color="primary" class="-mt-4 -mb-6 ml-auto"
                    (click)="requestChange(0, sharedService.address, sharedService.change)">Change Physical Address</button>
                </div>
                <address [entityId]="license.id"
                         [entityType]="sharedService.inHomeCareLicense"
                         [canEdit]="!locked"
                         [limitEntries]="true"
                         (addressesLoaded)="addressesLoadedEvent($event)"
                         (updatedPhysicalAddress)="getDistanceToParent()"
                         (reportDistance)="updateLicenseDistance($event)"></address>

                <span class="font-semibold">Agency Physically Located within</span>
                <form [formGroup]="licenseForm">
                  <div class="flex flex-col">
                    <mat-form-field appearance="fill">
                      <input matInput formControlName="agencyPhysicalLocation" style="display: none;">
                      <mat-radio-group class="flex flex-col" aria-labelledby="agency-physical-location" formControlName="agencyPhysicalLocation">
                        <mat-radio-button value="Commercial Business Building">
                          Commercial Business Building
                        </mat-radio-button>
                        <mat-radio-button value="Private Home Residence">
                          Private Home/Residence
                        </mat-radio-button>
                        <mat-radio-button value="Independent Living Retirement Facility or Community">
                          Independent Living Retirement Facility or Community
                        </mat-radio-button>
                        <mat-radio-button value="Registered Continuing Care Retirement Community">
                          Registered Continuing Care Retirement Community
                        </mat-radio-button>
                        <mat-radio-button value="Other Licensed Facility or Agency Type">
                          Other Licensed Facility or Agency Type
                        </mat-radio-button>
                      </mat-radio-group>
                      <mat-error *ngIf="licenseForm.get('agencyPhysicalLocation')?.hasError('required')">
                        You must select a classification level
                      </mat-error>
                    </mat-form-field>

                    <div class="flex flex-col gap-2 md:w-1/2"
                      *ngIf="licenseForm.get('agencyPhysicalLocation')?.value === 'Other Licensed Facility or Agency Type'">
                      <span class="font-semibold">Other Licensed Facility or Agency Type</span>
                      <mat-form-field>
                        <mat-label>Location Type</mat-label>
                        <input matInput formControlName="otherLocation" (blur)="validatePhysicalLocation()">
                        <mat-error *ngIf="licenseForm.get('otherLocation')?.invalid">
                          Location required
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </form>

              </div>
            </mat-card-content>
          </mat-card>

          <mat-card
            *ngIf="licenseForm.get('agencyPhysicalLocation')?.value === 'Private Home Residence'">
            <mat-card-content>
              <document [entityId]="license.id"
                        [entityType]="sharedService.inHomeCareLicense"
                        [statuses]="license.statuses"
                        [types]="inHomeCareTypes"></document>
            </mat-card-content>
          </mat-card>
        </div>
      </div>

      <div class="flex flex-col md:flex-row md:gap-4 pt-4">
        <button class="text-xl" mat-raised-button matStepperPrevious type="button">Back</button>
        <button class="text-xl" mat-raised-button matStepperNext type="button">Next</button>
      </div>
    </mat-step>

    <!--
      Branch Operations
    -->
    <mat-step>
      <ng-template matStepLabel>
        <span matTooltip="Branch Operations" matTooltipPosition="below" [matTooltipShowDelay]="500">Branch Operations</span>
      </ng-template>
      <ng-template matStepContent>
        <branch-operation [entityId]="license.id"
                          [entityType]="sharedService.inHomeCareLicense"
                          [entityGuid]="license.licenseId ?? ''"
                          [statuses]="license.statuses"
                          [agencyAddresses]="addresses?.addresses ?? []"
                          [isChange]="false"></branch-operation>

        <div class="flex flex-col md:flex-row md:gap-4 pt-4">
          <button class="text-xl" mat-raised-button matStepperPrevious type="button">Back</button>
          <button class="text-xl" mat-raised-button matStepperNext type="button">Next</button>
        </div>
        <div class="pt-4" *ngFor="let error of branchErrors">
          <span class="portal-error pl-8">{{error}}</span>
        </div>
      </ng-template>
    </mat-step>

    <!--
      Agency Owner(s)
    -->
    <mat-step>
      <ng-template matStepLabel>
        <span matTooltip="Agency Owner(s)" matTooltipPosition="below" [matTooltipShowDelay]="500">Agency Owner(s)</span>
      </ng-template>
      <ng-template matStepContent>
        <div class="flex flex-col gap-2">
          <span class="text-xl font-semibold">Owner Information</span>
          <span class="text-lg">
            Provide contact information for each of the owners
          </span>

          <entity-owner [entityId]="license.id"
                        [entityType]="sharedService.inHomeCareLicense"
                        [entityGuid]="license.licenseId ?? ''"
                        [parentId]="parentId"
                        [isSubunit]="license.isSubunit ?? false"
                        [statuses]="license.statuses">
          </entity-owner>
        </div>

        <div class="flex flex-col md:flex-row md:gap-4 pt-4">
          <button class="text-xl" mat-raised-button matStepperPrevious type="button">Back</button>
          <button class="text-xl" mat-raised-button matStepperNext type="button">Next</button>
        </div>
        <div class="pt-4" *ngFor="let error of ownerErrors">
          <span class="portal-error pl-8">{{error}}</span>
        </div>
      </ng-template>
    </mat-step>

    <!--
      Administrator Application
    -->
    <mat-step>
      <ng-template matStepLabel>
        <span matTooltip="Administrator Application" matTooltipPosition="below" [matTooltipShowDelay]="500">Administrator Application</span>
      </ng-template>
      <ng-template matStepContent>
        <div class="flex flex-col gap-2">
          <administrator-application [entityId]="license.id"
                                     [entityGuid]="license.licenseId ?? ''"
                                     [entityType]="sharedService.inHomeCareLicense"
                                     [isChange]="false"
                                     [statuses]="license.statuses"></administrator-application>
          <div class="flex flex-col md:flex-row md:gap-4 pt-4">
            <button class="text-xl" mat-raised-button matStepperPrevious type="button">Back</button>
            <button class="text-xl" mat-raised-button matStepperNext type="button">Next</button>
          </div>
        </div>
        <div class="pt-4" *ngFor="let error of adminErrors">
          <span class="portal-error pl-8">{{error}}</span>
        </div>
      </ng-template>
    </mat-step>

    <!--
      Agency Policies and Prodedures
    -->
    <mat-step>
      <ng-template matStepLabel>
        <span matTooltip="Agency Policies and Procedures" matTooltipPosition="below" [matTooltipShowDelay]="500">Agency Policies and Procedures</span>
      </ng-template>
      <div class="flex flex-col">
        <div class="flex flex-col md:flex-row gap-2">
          <div class="flex flex-col md:w-1/2">
            <span class="text-lg">
              Develop agency specific policies and procedures (including associated forms such as the initial assessment form, disclosure form, etc.)
              to address and ensure compliance with the IHC OAR's, Division 536. Every rule listed below must be included,
              each having at least one policy, procedure, and form/documentation that demonstrate compliance with the following requirements:
            </span>

            <button type="button"  class="portal-text-action pt-4" (click)="downloadReferenceDocument(sharedService.policyAndProcedure)">
              Download Policy and Procedure Reference Document
            </button>

            <span class="text-lg">OAR 333-536-0045 Services Provided (All Classifications)</span>
            <span class="text-lg">OAR 333-536-0050 Organization, Administration, and Personnel (All Classifications)</span>
            <span class="text-lg">OAR 333-536-0051 Policies and Procedures (All Classifications)</span>
            <span class="text-lg">OAR 333-536-0052 Administrator (All Classifications)</span>
            <span class="text-lg">OAR 333-536-0053 Personnel Records (All Classifications)</span>
            <span class="text-lg">OAR 333-536-0055 Disclosure, Screening and Acceptance of Clients (All Classifications)</span>
            <span class="text-lg">OAR 333-536-0060 Client's Rights (All Classifications)</span>
            <span class="text-lg">OAR 333-536-0065 Service Plan (All Classifications)</span>
            <span class="text-lg">OAR 333-536-0066 Initial Visit and Monitoring (All Classifications)</span>
            <span class="text-lg">OAR 333-536-0070(1-7) & (9-15) Caregiver Training (Limited)</span>
            <span class="text-lg">OAR 333-536-0070 Caregiver Training (Basic, Intermediate, Comprehensive)</span>
            <span class="text-lg">OAR 333-536-0075(1-2) & (4-6) Medication Services (Basic, Intermediate, Comprehensive)</span>
            <span class="text-lg">OAR 333-536-0075(3) Medication Services – Medication Administration (Intermediate and Comprehensive)</span>
            <span class="text-lg">OAR 333-536-0080 Nursing Services (Comprehensive)</span>
            <span class="text-lg">OAR 333-536-0082 Infection Control (All Classifications)</span>
            <span class="text-lg">OAR 333-536-0085 Client Records (All Classifications)</span>
            <span class="text-lg">OAR 333-536-0090 Quality Assessment and Performance Improvement (All Classifications)</span>
            <span class="text-lg">OAR 333-536-0093 Criminal Records Checks (All Classifications)</span>
          </div>

          <document class="md:w-1/2" [entityId]="license.id" [entityType]="sharedService.inHomeCareLicense"
            [statuses]="license.statuses" [types]="policyAndProcedureTypes"></document>
        </div>
        <div class="flex flex-col md:flex-row md:gap-4 pt-4">
          <button class="text-xl" mat-raised-button matStepperPrevious type="button">Back</button>
          <button class="text-xl" mat-raised-button matStepperNext type="button">Next</button>
        </div>
      </div>
      <div class="pt-4" *ngFor="let error of documentErrors">
        <span class="portal-error pl-8">{{error}}</span>
      </div>
    </mat-step>

    <!--
      Fee Information
    -->
    <mat-step>
      <ng-template matStepLabel>
        <span matTooltip="Fee Information" matTooltipPosition="below" [matTooltipShowDelay]="500">Fee Information</span>
      </ng-template>
      <app-payment-notice class="flex md:w-1/2"
                          [canPay]="locked"
                          [id]="license.id"
                          [sku]="paymentService.getIHCSku(license.classificationLevel ?? '', license.isRenewal ?? false)"
                          [entityType]="sharedService.inHomeCareLicense"
                          feeType="ApplicationFee"></app-payment-notice>
      <div class="flex flex-col md:flex-row md:gap-4 pt-4">
        <button class="text-xl" mat-raised-button matStepperPrevious type="button">Back</button>
        <button class="text-xl" mat-raised-button matStepperNext type="button">Next</button>
      </div>
    </mat-step>

    <!--
      Submit Application
    -->
    <mat-step>
      <ng-template matStepLabel>
        <span matTooltip="Submit Application" matTooltipPosition="below" [matTooltipShowDelay]="500">Submit Application</span>
      </ng-template>
      <div class="flex flex-col md:flex-row gap-4">
        <div class="flex flex-col gap-4 md:w-1/2" *ngIf="!locked">
          <span class="font-semibold text-lg">I declare, under penalties of perjury, that I have examined this
            application and
            all attachments and that to the best of my knowledge and belief, this information is true, correct and
            complete.
            I will notify the Health Care Regulation and Quality Improvement Section, in writing, of any changes
            in this information as required.</span>

          <span class="font-semibold text-lg">If this application leads to employment, I understand that false or
            misleading information in my application or interview may result in my release.
          </span>

          <form [formGroup]="signatureForm">
            <div class="flex flex-col md:flex-row gap-2">
              <div class="flex flex-col gap-2 md:w-1/2">
                <span class="font-semibold">Administrator Signature</span>
                <mat-form-field>
                  <mat-label>Signature</mat-label>
                  <input matInput formControlName="electronicSignature">
                  <mat-error *ngIf="signatureForm.get('electronicSignature')?.invalid">
                    A name is required
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="flex flex-col gap-2 md:w-1/2">
                <span class="font-semibold">Title</span>
                <mat-form-field>
                  <mat-label>Title</mat-label>
                  <input matInput formControlName="adminPrintTitle">
                  <mat-error *ngIf="signatureForm.get('adminPrintTitle')?.invalid">
                    A name is required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="flex flex-col md:flex-row gap-2 md:items-center">
              <div class="flex flex-col gap-2 md:w-1/2">
                <span class="font-semibold">Date</span>
                <mat-form-field>
                  <input placeholder="mm/dd/yyyy" formControlName="signedDate" matInput [matDatepicker]="signed"
                    [max]="sharedService.today" />
                  <mat-datepicker-toggle matSuffix [for]="signed"></mat-datepicker-toggle>
                  <mat-datepicker #signed>
                    <mat-datepicker-actions>
                      <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                      <button mat-button matDatepickerCancel>Cancel</button>
                    </mat-datepicker-actions>
                  </mat-datepicker>
                  <mat-error *ngIf="signatureForm.get('signedDate')?.invalid">
                    Signature date required
                  </mat-error>
                </mat-form-field>
              </div>
              <button *ngIf="licenseForm.valid &&
                      validationErrors.length === 0 &&
                      !distanceInvalid &&
                      signatureForm.valid"
                      type="button" class="ml-auto" mat-flat-button color="primary" (click)="submitLicense()">Submit</button>
            </div>
          </form>
        </div>

        <div class="flex flex-col gap-4 md:w-1/2" *ngIf="(!licenseForm.valid || validationErrors.length > 0) && !licenseForm.disabled">
          <span class="text-xl portal-error">Your Application is Incomplete</span>
          <span class="text-lg portal-error">Missing information must be provided before you can submit your
            application</span>
          <span class="portal-error pl-8" *ngIf="!licenseForm.valid">Agency Information is Incomplete</span>
          <div *ngFor="let error of validationErrors">
            <span class="portal-error pl-8">{{error}}</span>
          </div>
        </div>

        <div class="flex flex-col gap-4 md:w-1/2" *ngIf="this.distanceInvalid">
          <span class="text-lg portal-error">
            The distance between the parent agency and the subunit appears to be fewer than 60 miles.
            You may not submit your application. Please contact the Health Care Regulation and Quality Improvement
            Section for further assistance.</span>
        </div>

        <div class="flex flex-col gap-4 md:w-1/2" *ngIf="license.calculatedDistance === 0 && license.isSubunit">
          <span class="text-lg text-amber-400">
            The distance between the parent and subunit could not be calculated.
            You may still submit your application and the distance will be determined by the department.
            If the distance is fewer than 60 miles your application will be denied.</span>
        </div>

      </div>

      <div class="flex flex-col gap-4 md:w-1/3" *ngIf="locked">
        <span class="text-xl font-semibold">Thank you for submitting your In-Home Care application.</span>
        <div class="flex flex-row gap-4">
          <span class="font-semibold">Signed by:</span>
          <span>{{license.electronicSignature}}</span>
        </div>
        <div class="flex flex-row gap-4">
          <span class="font-semibold">Title:</span>
          <span>{{license.adminPrintTitle}}</span>
        </div>
        <div class="flex flex-row gap-4">
          <span class="font-semibold">Date:</span>
          <span>{{license.signedDate | date}}</span>
        </div>

        <span class="text-lg">Applications will be processed in the order they are received.
          If you have questions about your application, please email
          <a href="mailto:mailbox.inhomecare@odhsoha.oregon.gov">mailbox.inhomecare&#64;odhsoha.oregon.gov</a>. Thank you.
        </span>
      </div>

      <div class="flex flex-col md:flex-row md:gap-4 pt-4">
        <button class="text-xl" mat-raised-button matStepperPrevious>Back</button>
        <button class="text-xl" *ngIf="!approved" mat-raised-button (click)="IHCLStepper.reset()">Reset</button>
        <button class="text-xl" *ngIf="approved" mat-raised-button matStepperNext type="button">Next</button>
      </div>
    </mat-step>

    <!--
      License Change Requests
    -->
    <mat-step *ngIf="approved || license.isRenewal">
      <ng-template matStepLabel>
        <span matTooltip="Change Requests" matTooltipPosition="below" [matTooltipShowDelay]="500">Change Requests</span>
      </ng-template>
      <ng-template matStepContent>
        <app-manage-in-home-care-changes [entityId]="license.id"></app-manage-in-home-care-changes>

        <div class="flex flex-col md:flex-row md:gap-4 pt-4">
          <button class="text-xl" mat-raised-button matStepperPrevious type="button">Back</button>
          <button class="text-xl" mat-raised-button (click)="IHCLStepper.reset()">Reset</button>
        </div>
      </ng-template>
    </mat-step>
  </mat-stepper>
</div>
